import React from 'react';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import FormHelper from 'helpers/FormHelper';
import FileList from '../../../../../../../components/fileList/index.';
import styles from '../../style.module.scss';
import { Descriptions } from 'antd';

const FileSection = ({
  singleItem,
  handleDeleteFile,
  updateInProcess,
  isView,
}) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={4}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={10}>
        <Form.Item>
          <Form.Item
            label={t('Verbale di consegna')}
            name='rent_file'
            getValueFromEvent={FormHelper.normFile}
            className={styles.fileFormItem}
          >
            <Upload.Dragger
              disabled={isView}
              name='files'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX', 'CSV'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX CSV
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem.rent_file
                  ? [{ file: singleItem.rent_file, param: 'rent_file' }]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col span={10}>
        <Form.Item>
          <Form.Item
            className={styles.fileFormItem}
            label={t('Verbale di riconsegna')}
            name='end_rent_file'
            getValueFromEvent={FormHelper.normFile}
          >
            <Upload.Dragger
              disabled={isView}
              name='files'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX', 'CSV'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX CSV
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem.end_rent_file
                  ? [
                      {
                        file: singleItem.end_rent_file,
                        param: 'end_rent_file',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item>
          <Form.Item
            className={styles.fileFormItem}
            label={t('Hot firmato')}
            name='hot_file_signed'
            getValueFromEvent={FormHelper.normFile}
          >
            <Upload.Dragger
              disabled={isView}
              name='files'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX', 'CSV'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX CSV
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem.hot_file_signed
                  ? [
                      {
                        file: singleItem.hot_file_signed,
                        param: 'hot_file_signed',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col span={10}>
        <Form.Item>
          <Form.Item
            className={styles.fileFormItem}
            label={t('Contratto')}
            name='contract_file'
            getValueFromEvent={FormHelper.normFile}
          >
            <Upload.Dragger
              disabled={isView}
              name='files'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX', 'CSV'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX CSV
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem.contract_file
                  ? [
                      {
                        file: singleItem.contract_file,
                        param: 'contract_file',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
